module.exports = __webpack_public_path__ + "ba44f797.png";


//////////////////
// WEBPACK FOOTER
// ./public/images/Validacion red.png
// module id = 1201
// module chunks = 0 1 2